import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/home'
import clean from '@/pages/clean'
import login from '@/pages/login'
import waitCollect from '@/pages/waitCollect'
import collect from '@/pages/collect'
import order from '@/pages/order'
import user from '@/pages/user'
import withdraw from '@/pages/withdraw'
import rebate from '@/pages/rebate'
import withdrawComplete from '@/pages/withdrawComplete'
import withdrawRecord from '@/pages/withdrawRecord'
import wareHouse from '@/pages/wareHouse'
import outHouse from '@/pages/outHouse'
import group from '@/pages/group'
import driver from '@/pages/driver'
import groupRebate from '@/pages/groupRebate'
import groupOrder from '@/pages/groupOrder'
import clearSession from '@/pages/clearSession'
import storeApply from '@/pages/storeApply'
import collectData from '@/pages/collectData'
import communityData from '@/pages/communityData'
import myData from '@/pages/myData'
import password from '@/pages/password'
import problem from '@/pages/problem'
import orderDetail from '@/pages/orderDetail'
import myInvite from '@/pages/myInvite'
import addVisit from '@/pages/addVisit'
import visit from '@/pages/visit'
import countReward from '@/pages/countReward'
import outTimeOrder from '@/pages/outTimeOrder'
import product from '@/pages/product'
import myProduct from '@/pages/myProduct'
import addProduct from '@/pages/addProduct'
import editUser from '@/pages/editUser'
import wash from '@/pages/wash'
import work from '@/pages/work'
import submitWork from '@/pages/submitWork'
import workorder from '@/pages/workorder'
import workOrderInfo from '@/pages/workOrderInfo'
import workOrderSolution from '@/pages/workOrderSolution'
import inviteUser from '@/pages/inviteUser'
import clotheStatus from '@/pages/clotheStatus'
import groupInvite from '@/pages/groupInvite'
import secondBd from '@/pages/secondBd'
import secondBdEdit from '@/pages/secondBdEdit'
import secondCommunity from '@/pages/secondCommunity'
import secondCommunityEdit from '@/pages/secondCommunityEdit'
import secondCommunityFactoryPrice from '@/pages/secondCommunityFactoryPrice'
import balance from '@/pages/balance'
import maps from '@/pages/maps'
import driverList from '@/pages/driverList'
import driverEdit from '@/pages/driverEdit'
import waitPickup from '@/pages/waitPickup'
import pickup from '@/pages/pickup'
import outFactory from '@/pages/outFactory'
import arrival from '@/pages/arrival'
import searchOrder from '@/pages/searchOrder'
import pickuped from '@/pages/pickuped'
import openMap from '@/pages/openMap'
import arrivaled from '@/pages/arrivaled'
import waitPickupInfo from '@/pages/waitPickupInfo'
import factory from '@/pages/factory'
import waitInFactory from '@/pages/waitInFactory'
import inFactory from '@/pages/inFactory'
import barOrder from '@/pages/barOrder'
import backwash from '@/pages/backwash'
import secondCommunityOrder from '@/pages/secondCommunityOrder'
import suborder from '@/pages/suborder'
import suboutTimeOrder from '@/pages/suboutTimeOrder'
import editBag from '@/pages/editBag'
import express from '@/pages/express'
import productVerify from '@/pages/productVerify'
import active from '@/pages/active'
import outHouseCode from '@/pages/outHouseCode'
import backStore from '@/pages/backStore'
import factoryBack from '@/pages/factoryBack'
import recordOrder from '@/pages/recordOrder'
import bagCodeRecord from '@/pages/bagCodeRecord'
import todayRecordList from '@/pages/todayRecordList'
import recordList from '@/pages/recordList'
import upClothe from '@/pages/upClothe'
import pickClothe from '@/pages/pickClothe'
import annex from '@/pages/annex'
import cancelRecord from '@/pages/cancelRecord'
import countInOutFactory from '@/pages/countInOutFactory'
import abnormal from '@/pages/abnormal'
import coupon from '@/pages/coupon'
import giveCoupon from '@/pages/giveCoupon'
import qrCoupon from '@/pages/qrCoupon'
import goodsCount from '@/pages/goodsCount'
import dataCount from '@/pages/dataCount'
import goodsAmountCount from '@/pages/goodsAmountCount'
import goodsGroupCount from '@/pages/goodsGroupCount'
import withdrawCleanRecord from '@/pages/withdrawCleanRecord'
import recordPhoneList from '@/pages/recordPhoneList'
import card from '@/pages/card'
import cardMember from '@/pages/cardMember'
import clothesConfirm from '@/pages/clothesConfirm'
import clothesConfirmInfo from '@/pages/clothesConfirmInfo'
import douYinVerify from '@/pages/douYinVerify'
import washBagCode from '@/pages/washBagCode'
import washHome from '@/pages/washHome'
import boxList from '@/pages/boxList'
import douyinOrder from '@/pages/douyinOrder'
import clotheWash from '@/pages/clotheWash'
import timeOutClotheWash from '@/pages/timeOutClotheWash'
import clothePhoto from '@/pages/clothePhoto'
import curtain from '@/pages/curtain'
import curtainGoods from '@/pages/curtainGoods'
import curtainAddGoods from '@/pages/curtainAddGoods'
import createCurtainOrder from '@/pages/createCurtainOrder'
import curtainOrder from '@/pages/curtainOrder'
import curtainOrderInfo from '@/pages/curtainOrderInfo'
import curtainMapOrder from '@/pages/curtainMapOrder'
import curtainWorker from '@/pages/curtainWorker'
import curtainAddWorker from '@/pages/curtainAddWorker'



Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      meta:{title:"首页"}
    },
      {
      path: '/curtain',
      name: 'curtain',
      component: curtain,
      meta:{title:"窗帘调度"}
    },
    {
      path: '/curtainGoods',
      name: 'curtainGoods',
      component: curtainGoods,
      meta:{title:"产品管理"}
    },
    {
      path: '/createCurtainOrder/:id?',
      name: 'createCurtainOrder',
      component: createCurtainOrder,
      meta:{
        title:"创建上门订单",
        keepAlive: true
      }
    },
    {
      path: '/curtainOrder/:i?/:commented?',
      name: 'curtainOrder',
      component: curtainOrder,
      meta:{
        title:"订单管理",
        // keepAlive: true
      }
    },
    {
      path: '/curtainOrderInfo/:id',
      name: 'curtainOrderInfo',
      component: curtainOrderInfo,
      meta:{
        title:"订单详情",
        // keepAlive: true
      }
    },
    {
      path: '/curtainAddGoods',
      name: 'curtainAddGoods',
      component: curtainAddGoods,
      meta:{title:"添加产品"}
    },
    {
      path: '/curtainWorker',
      name: 'curtainWorker',
      component: curtainWorker,
      meta:{title:"组员管理"}
    },
    {
      path: '/curtainAddWorker/:id?',
      name: 'curtainAddWorker',
      component: curtainAddWorker,
      meta:{title:"组员编辑"}
    },
     {
      path: '/curtainMapOrder/:status?/:dateStr?',
      name: 'curtainMapOrder',
      component: curtainMapOrder,
      meta:{title:"地图订单"}
    },
    {
      path: '/work',
      name: 'work',
      component: work,
      meta:{title:"工单"}
    },
    {
      path: '/douYinVerify',
      name: 'douYinVerify',
      component: douYinVerify,
      meta:{title:"抖音团购核销"}
    },
    {
      path: '/douyinOrder',
      name: 'douyinOrder',
      component: douyinOrder,
      meta:{title:"抖音团购订单"}
    },
    {
      path: '/washBagCode',
      name: 'washBagCode',
      component: washBagCode,
      meta:{title:"送洗码"}
    },
     {
      path: '/washHome',
      name: 'washHome',
      component: washHome,
      meta:{title:"上门收衣"}
    },
     {
      path: '/clotheWash',
      name: 'clotheWash',
      component: clotheWash,
      meta:{title:"洗涤中"}
    },
     {
      path: '/timeOutClotheWash',
      name: 'timeOutClotheWash',
      component: timeOutClotheWash,
      meta:{title:"超时衣物"}
    },
    {
      path: '/card',
      name: 'card',
      component: card,
      meta:{title:"会员卡"}
    },
    {
      path: '/countInOutFactory',
      name: 'countInOutFactory',
      component: countInOutFactory,
      meta:{title:"进出厂数据"}
    },
    {
      path: '/clothesConfirm',
      name: 'clothesConfirm',
      component: clothesConfirm,
      meta:{
        title:"衣物确认",
        keepAlive: true
      }
    },
    {
      path: '/clothesConfirmInfo/:id?',
      name: 'clothesConfirmInfo',
      component: clothesConfirmInfo,
      meta:{title:"衣物确认"}
    },
    {
      path: '/user',
      name: 'user',
      component: user,
      meta:{title:"我的"}
    },
    {
      path: '/active',
      name: 'active',
      component: active,
      meta:{title:"免洗活动赠送"}
    },
    {
      path: '/withdrawCleanRecord',
      name: 'withdrawCleanRecord',
      component: withdrawCleanRecord,
      meta:{title:"家政提现"}
    },
    {
      path: '/clean',
      name: 'clean',
      component: clean,
      meta:{title:"家政"}
    },
    {
      path: '/wash',
      name: 'wash',
      component: wash,
      meta:{title:"洗衣"}
    },
      {
      path: '/boxList',
      name: 'boxList',
      component: boxList,
      meta:{title:"盒子列表"}
    },
    {
      path: '/recordOrder',
      name: 'recordOrder',
      component: recordOrder,
      meta:{title:"洗衣录单"}
    },
    {
      path: '/clothePhoto',
      name: 'clothePhoto',
      component: clothePhoto,
      meta:{title:"衣物图片"}
    },
    {
      path: '/pickClothe',
      name: 'pickClothe',
      component: pickClothe,
      meta:{title:"顾客取衣"}
    },
    {
      path: '/upClothe',
      name: 'upClothe',
      component: upClothe,
      meta:{title:"衣物上挂"}
    },
    {
      path: '/coupon/:type?',
      name: 'coupon',
      component: coupon,
      meta:{title:"平台优惠券"}
    },
    {
      path: '/annex',
      name: 'annex',
      component: annex,
      meta:{title:"附件补录"}
    },
    {
      path: '/abnormal',
      name: 'abnormal',
      component: abnormal,
      meta:{title:"异常报备"}
    },
    {
      path: '/cancelRecord',
      name: 'cancelRecord',
      component: cancelRecord,
      meta:{title:"撤单"}
    },
    {
      path: '/todayRecordList',
      name: 'todayRecordList',
      component: todayRecordList,
      meta:{
        title:"今日送洗",
        keepAlive: true
      }
    },
    {
      path: '/recordList',
      name: 'recordList',
      component: recordList,
      meta:{
        title:"综合查询",
        keepAlive: true
      }
    },
    {
      path: '/recordPhoneList',
      name: 'recordPhoneList',
      component: recordPhoneList,
      meta:{
        title:"手机号查询",
        keepAlive: true
      }
    },
    {
      path: '/cardMember/:i?',
      name: 'cardMember',
      component: cardMember,
      meta:{title:"会员用户"}
    },
    {
      path: '/bagCodeRecord/:type/:order_no?',
      name: 'bagCodeRecord',
      component: bagCodeRecord,
      meta:{title:"衣物录单"}
    },
    {
      path: '/backStore',
      name: 'backStore',
      component: backStore,
      meta:{title:"回店记录"}
    },
    {
      path: '/goodsCount',
      name: 'goodsCount',
      component: goodsCount,
      meta:{title:"洗衣店普通商品统计"}
    },
    {
      path: '/goodsAmountCount',
      name: 'goodsAmountCount',
      component: goodsAmountCount,
      meta:{title:"洗衣店各项收入统计"}
    },
    {
      path: '/goodsGroupCount',
      name: 'goodsGroupCount',
      component: goodsGroupCount,
      meta:{title:"洗衣店团购商品统计"}
    },
    {
      path: '/dataCount',
      name: 'dataCount',
      component: dataCount,
      meta:{title:"数据统计"}
    },
    {
      path: '/giveCoupon/:id',
      name: 'giveCoupon',
      component: giveCoupon,
      meta:{title:"优惠券赠送"}
    },
    {
      path: '/qrCoupon/:id',
      name: 'qrCoupon',
      component: qrCoupon,
      meta:{title:"优惠券领取码"}
    },
    {
      path: '/driver',
      name: 'driver',
      component: driver,
      meta:{title:"物流"}
    },
    {
      path: '/factory',
      name: 'factory',
      component: factory,
      meta:{title:"工厂"}
    },
    {
      path: '/express',
      name: 'express',
      component: express,
      meta:{title:"快递下单"}
    },
    {
      path: '/barOrder/:code?',
      name: 'barOrder',
      component: barOrder,
      meta:{title:"条码查询"}
    },
    {
      path: '/productVerify',
      name: 'productVerify',
      component: productVerify,
      meta:{title:"订单核销"}
    },
    {
      path: '/inFactory/:i',
      name: 'inFactory',
      component: inFactory,
      meta:{title:"入厂"}
    },
    {
      path: '/backwash/:i',
      name: 'backwash',
      component: backwash,
      meta:{title:"回进厂"}
    },
    {
      path: '/waitInFactory/:i/:type',
      name: 'waitInFactory',
      component: waitInFactory,
      meta:{title:"待入厂"}
    },
    {
      path: '/product',
      name: 'product',
      component: product,
      meta:{title:"商品"}
    },
    {
      path: '/myProduct',
      name: 'myProduct',
      component: myProduct,
      meta:{title:"本店商品"}
    },
    {
      path: '/submitWork',
      name: 'submitWork',
      component: submitWork,
      meta:{title:"发起工单"}
    },
    {
      path: '/clotheStatus',
      name: 'clotheStatus',
      component: clotheStatus,
      meta:{title:"衣物状态"}
    },
    {
      path: '/workorder/:i',
      name: 'workorder',
      component: workorder,
      // meta:{title:"工单列表"}
      meta:{
        title:"工单列表",
        keepAlive: true
      }
    },
    {
      path: '/workOrderInfo/:id',
      name: 'workOrderInfo',
      component: workOrderInfo,
      meta:{title:"工单详情"}
    },
    {
      path: '/workOrderSolution/:id',
      name: 'workOrderSolution',
      component: workOrderSolution,
      meta:{title:"工单处理办法"}
    },
    {
      path: '/addProduct/:id?',
      name: 'addProduct',
      component: addProduct,
      meta:{title:"添加商品"}
    },
    {
      path: '/password',
      name: 'password',
      component: password,
      meta:{title:"修改密码"}
    },
    {
      path: '/editUser',
      name: 'editUser',
      component: editUser,
      meta:{title:"站点信息"}
    },
   
    
    {
      path: '/myInvite',
      name: 'myInvite',
      component: myInvite,
      meta:{title:"我的下级"}
    },
    {
      path: '/secondCommunityOrder',
      name: 'secondCommunityOrder',
      component: secondCommunityOrder,
      meta:{title:"下级团长订单"}
    },
    {
      path: '/secondCommunityFactoryPrice/:cid?',
      name: 'secondCommunityFactoryPrice',
      component: secondCommunityFactoryPrice,
      meta:{title:"下级门店加工价格"}
    },
    {
      path: '/inviteUser',
      name: 'inviteUser',
      component: inviteUser,
      meta:{title:"我的推广"}
    },
    {
      path: '/secondBd',
      name: 'secondBd',
      component: secondBd,
      meta:{title:"下级BD"}
    },
    {
      path: '/maps/:latitude?/:longitude?',
      name: 'maps',
      component: maps,
      meta:{title:"位置选择"}
    },
    {
      path: '/secondBdEdit/:id?',
      name: 'secondBdEdit',
      component: secondBdEdit,
      meta:{title:"BD编辑"}
    },
    {
      path: '/secondCommunityEdit/:id?',
      name: 'secondCommunityEdit',
      component: secondCommunityEdit,
      // meta:{title:"团长编辑"}
      meta:{
        title:"编辑",
        keepAlive: true
      }
    },
    {
      path: '/secondCommunity',
      name: 'secondCommunity',
      component: secondCommunity,
      meta:{title:"下级门店"}
    },
    {
      path: '/groupInvite',
      name: 'groupInvite',
      component: groupInvite,
      meta:{title:"组员推广"}
    },
  
    {
      path: '/collectData',
      name: 'collectData',
      component: collectData,
      meta:{title:"楼管收衣数据"}
    },
    {
      path: '/communityData',
      name: 'communityData',
      component: communityData,
      meta:{title:"小区收衣数据"}
    },
    {
      path: '/myData',
      name: 'myData',
      component: myData,
      meta:{title:"我的收衣数据"}
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta:{title:"登录"}
    },
    {
      path: '/outTimeOrder',
      name: 'outTimeOrder',
      component: outTimeOrder,
      meta:{title:"超时订单"}
    },
    {
      path: '/suboutTimeOrder',
      name: 'suboutTimeOrder',
      component: suboutTimeOrder,
      meta:{title:"下级团长超时订单"}
    },
    {
      path: '/addVisit/:cid/:title/:id?',
      name: 'addVisit',
      component: addVisit,
      meta:{title:"新增拜访记录"}
    },
    {
      path: '/visit/:cid/:title',
      name: 'visit',
      component: visit,
      meta:{title:"拜访记录"}
    },
    // {
    //   path: '/order/:type/:i',
    //   name: 'order',
    //   component: order,
    //   meta:{title:"订单"}
    // },
     {
      path: '/order/:type/:i/:deliveryWay?',
      name: 'order',
      component: order,
      meta:{title:"订单"}
    },
    {
      path: '/suborder/:type/:i',
      name: 'suborder',
      component: suborder,
      meta:{title:"下级团长订单"}
    },
    {
      path: '/orderDetail/:id',
      name: 'orderDetail',
      component: orderDetail,
      meta:{title:"订单详情"}
    },
    {
      path: '/problem/:id',
      name: 'problem',
      component: problem,
      meta:{title:"问题上报"}
    },
    {
      path: '/waitCollect',
      name: 'waitCollect',
      component: waitCollect,
      meta:{title:"待送洗"}
    },
    {
      path: '/collect/:id',
      name: 'collect',
      component: collect,
      meta:{title:"收衣物"}
    },
    {
      path: '/wareHouse',
      name: 'wareHouse',
      component: wareHouse,
      meta:{title:"洗衣入库"}

    },
    {
      path: '/outHouse',
      name: 'outHouse',
      component: outHouse,
      meta:{title:"衣物出库"}

    },
    {
      path: '/outHouseCode',
      name: 'outHouseCode',
      component: outHouseCode,
      meta:{title:"扫码出库"}

    },
    {
      path: '/withdraw',
      name: 'withdraw',
      component: withdraw,
      meta:{title:"提现"}
    },
    {
      path: '/balance',
      name: 'balance',
      component: balance,
      meta:{title:"平台账户"}
    },
    {
      path: '/rebate/:uid?/:otherId?',
      name: 'rebate',
      component: rebate,
      meta:{title:"收益记录"}
    },
    {
      path: '/withdrawComplete',
      name: 'withdrawComplete',
      component: withdrawComplete,
      meta:{title:"提现完成"}
    },
    {
      path: '/withdrawRecord',
      name: 'withdrawRecord',
      component: withdrawRecord,
      meta:{title:"提现记录"}
    },
    {
      path: '/group',
      name: 'group',
      component: group,
      meta:{title:"渠道中心"}
    },
   
    {
      path: '/groupRebate',
      name: 'groupRebate',
      component: groupRebate,
      meta:{title:"渠道收益"}
    },
    {
      path: '/groupOrder',
      name: 'groupOrder',
      component: groupOrder,
      meta:{title:"全部订单"}
    },
    {
      path: '/clearSession',
      name: 'clearSession',
      component: clearSession,
      meta:{title:"缓存清理"}
    },
    {
      path: '/storeApply',
      name: 'storeApply',
      component: storeApply,
      meta:{title:"合伙人招募"}
    },
    {
      path: '/countReward',
      name: 'countReward',
      component: countReward,
      meta:{title:"收入统计"}
    },
    {
      path: '/driverList',
      name: 'driverList',
      component: driverList,
      meta:{
        title:"物流司机",
        keepAlive: true
      }
    },
    {
      path: '/driverEdit/:id',
      name: 'driverEdit',
      component: driverEdit,
      meta:{title:"编辑"}
    },
    {
      path: '/waitPickup/:i',
      name: 'waitPickup',
      component: waitPickup,
      meta:{title:"待取件"}
    },
    {
      path: '/pickup',
      name: 'pickup',
      component: pickup,
      meta:{title:"取件"}
    },
    {
      path: '/outFactory',
      name: 'outFactory',
      component: outFactory,
      meta:{title:"出厂"}
    },
    {
      path: '/arrival',
      name: 'arrival',
      component: arrival,
      meta:{title:"到站"}
    },
    {
      path: '/editBag',
      name: 'editBag',
      component: editBag,
      meta:{title:"修改扎带码"}
    },
    {
      path: '/factoryBack',
      name: 'factoryBack',
      component: factoryBack,
      meta:{title:"不洗退回"}
    },
    {
      path: '/searchOrder/:code?',
      name: 'searchOrder',
      component: searchOrder,
      meta:{title:"查询订单"}
    },
    {
      path: '/openMap/:id',
      name: 'openMap',
      component: openMap,
      meta:{title:"查看地图"}
    },
    {
      path: '/pickuped',
      name: 'pickuped',
      component: pickuped,
      meta:{title:"已取件"}
    },
    {
      path: '/arrivaled',
      name: 'arrivaled',
      component: arrivaled,
      meta:{title:"已到站"}
    },
    {
      path: '/waitPickupInfo/:cid/:i/:type',
      name: 'waitPickupInfo',
      component: waitPickupInfo,
      meta:{title:"配送详情"}
    },
  
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js